import * as React from 'react';

import { createIcon } from '../Icon';
export const SmartphoneIcon = createIcon(
  <React.Fragment>
    <rect height={20} rx={2} ry={2} width={14} x={5} y={2} />
    <line x1={12} x2={12.01} y1={18} y2={18} />
  </React.Fragment>,
  'SmartphoneIcon'
);
